import React from 'react';

const About: React.FC = () => {
  return (
    <div className="card">
      <div className="card-header">
        <h5 className="mb-0">About</h5>
      </div>
      <div className="card-body">
        <p className="mb-0">This application is built for the Travancore Devaswom Board / Sabarimala Devaswom to manage Kanikka Vanchi operations and master records.</p>
      </div>
    </div>
  );
};

export default About;
